<template>
  <v-card outlined v-if="selectedDestiny != null" class="mt-4">
    <v-card-text>
      <v-container class="pa-0">
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                  id="options-anchor"
                  :value="pago"
                  :items="optionsPago"
                  @change="updatePago"
                  label="Pago"
                  hint="Ctrl + O"
                  persistent-hint
                  dense
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-select
                  :value="fabricacion"
                  @change="updateFabricacion"
                  :items="optionsFabricacion"
                  label="Fabricación"
                  dense
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-select
                  :value="entrega"
                  @change="updateEntrega"
                  :items="optionsEntrega"
                  label="Entrega"
                  dense
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="12">
                <p class="mb-0">
                  <span>Subtotal:</span>
                  {{ subtotal | currency }}
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <p class="mb-0">
                  <span>I.V.A.:</span>
                  {{ iva | currency }}
                </p>
              </v-col>
              <v-col cols="12" md="12">
                <p>
                  <span class="font-weight-bold">Total:</span>
                  {{ total | currency }}
                </p>
              </v-col>
              <v-col cols="12" md="12" class="d-flex justify-center">
                <v-menu offset-y v-if="items.length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      x-small
                    >
                      <v-icon>mdi-alert</v-icon>
                    </v-btn>
                  </template>
                  <v-card max-width="320">
                    <v-card-title class="warning white--text">
                      Advertencia
                    </v-card-title>
                    <v-card-text>
                      <p class="text-subheading-1 text-justify mt-4">
                        Los siguientes productos no tienen un dato de peso. Por
                        lo tanto,
                        <span class="font-weight-bold">
                          no se considerarán en el cálculo del peso total.</span
                        >
                      </p>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in items"
                          :key="index"
                        >
                          <v-list-item-title>{{
                            item.descripcion
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-menu>
                <p>
                  <span class="font-weight-bold">Peso Total:</span>
                  {{ pesoTotal | number }} KG
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12">
            <v-textarea
              :value="observaciones"
              @input="updateObservaciones"
              label="Observaciones"
              rows="2"
              dense
              no-resize
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      optionsPago: [
        "Contado",
        "50% anticipio + 50% contra aviso de entrega",
        "Crédito",
      ],
      optionsFabricacion: [
        "Material en stock",
        "24-48 horas",
        "1 semana",
        "15 días hábiles",
        "4-6 semanas",
      ],
      optionsEntrega: [
        "Inmediato",
        "Cliente recoge",
        "1 a 2 días",
        "Envío en plataforma consolidada, en caso de no haber transporte debe pagar plataforma completa",
      ],
      obs: null,
    };
  },
  computed: {
    selectedDestiny() {
      return this.$store.state.destinies.selectedDestiny;
    },
    pago() {
      return this.$store.state.pago;
    },
    fabricacion() {
      return this.$store.state.fabricacion;
    },
    entrega() {
      return this.$store.state.entrega;
    },
    observaciones() {
      return this.$store.state.observaciones;
    },
    pesoTotal() {
      return this.$store.state.pesoTotal;
    },
    total() {
      return this.$store.state.total;
    },
    subtotal() {
      return this.$store.state.subtotal;
    },
    iva() {
      return this.$store.state.iva;
    },
    items() {
      return this.$store.state.warningsPeso;
    },
  },
  methods: {
    updatePago(value) {
      this.$store.commit("setPago", value);
    },
    updateFabricacion(value) {
      this.$store.commit("setFabricacion", value);
    },
    updateEntrega(value) {
      this.$store.commit("setEntrega", value);
    },
    updateObservaciones(value) {
      this.$store.commit("setObservaciones", value);
    },
  },
};
</script>

<style>
</style>